import styled from "styled-components";
import { colors } from "assets";

export default c => styled(c)`
  .integration-status {
    display: inline-flex;
  }

  .tooltip {
    padding: 10px 0px 0px 6px;
  }

  .tooltip-icon {
    color: ${colors.primary.dark};
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/mercado-pago/style.js